import React, { useState, useEffect } from 'react'

import { Header } from './Header'
import Title from "../images/Social/cs-title-en.png"
import Blackcontect from '../images/Social/yellow_black.png'
import Logo from "../images/Social/logo.png"
import Customerservice from "../images/Social/clrwhatsapp.png"
import Customerservice247 from "../images/Social/contect247.png"
import Socialtelegram from "../images/Social/clrtelegram.png"
import Socialtelegram2 from "../images/Social/telecolor2.png"
import { Carausel } from './Carausel'
import { Footer } from './Footer'
import { Deposit } from './Deposit/Deposit'
import { Emailpopup } from './Emailpopup'
import { VerifyPhone } from './VerifyPhone'
import { Skycricket } from './Sports/Skycricket'
import { Casino } from './Casino/Casino'
import { Skyslot } from './Slot/Skyslot'



export function detectMobile() {
  var check = false;
  (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

export const Combine = (props) => {

  var eventId = null;
  var marketId = null;
  var eventT = 1;
  var isMobil = detectMobile();





  if (isMobil && !(props.match.params.eventType === 'exchange' && props.match.params.subType === 'member' && props.match.params.belowType === 'myprofile' || props.match.params.eventType === 'exchange' && props.match.params.subType === 'member' && props.match.params.belowType === 'balance' || props.match.params.eventType === 'exchange' && props.match.params.subType === 'member' && props.match.params.belowType === 'AccountStatement' || props.match.params.eventType === 'exchange' && props.match.params.subType === 'member' && props.match.params.belowType === 'mybets' || props.match.params.eventType === 'exchange' && props.match.params.subType === 'member' && props.match.params.belowType === 'bethistory' || props.match.params.eventType === 'exchange' && props.match.params.subType === 'member' && props.match.params.belowType === 'ProfitLoss' || props.match.params.eventType === 'exchange' && props.match.params.subType === 'member' && props.match.params.belowType === 'casinoProfitLoss')) {
    window.location.reload();
  }
  if (props.match.params.eventT === '4' || props.match.params.eventT === '1' || props.match.params.eventT === '2') {
    eventId = props.match.params.eventId;
    marketId = props.match.params.marketId;
    eventT = 0;
  }
  if (props.match.params.eventType === 'home') {
    eventT = 1;
  }
  if (props.match.params.eventType === 'deposit') {
    eventT = 2;
  }
  if (props.match.params.eventType === 'wallet') {
    eventT = 3;
  }
  if (props.match.params.eventType === 'bettingrecord') {
    eventT = 4;
  }
  if (props.match.params.eventType === 'turnover') {
    eventT = 5;
  }
  if (props.match.params.eventType === 'transactionrecord') {
    eventT = 6;
  }
  if (props.match.params.eventType === 'personalinfo') {
    eventT = 7;
  }
  if (props.match.params.eventType === 'verifyaccount') {
    eventT = 8;
  }
  if (props.match.params.eventType === 'resetpassword') {
    eventT = 9;
  }
  if (props.match.params.eventType === 'inbox') {
    eventT = 10;
  }
  if (props.match.params.eventType === 'referral') {
    eventT = 11;
  }
  if (props.match.params.eventType === 'skyexch') {
    eventT = 12;
  }
  if (props.match.params.eventType === 'cricket') {
    eventT = 13;
  }

  if (props.match.params.eventType === 'fullmarket') {
    eventT = 14;
  }
  if (props.match.params.eventType === 'soccermatches') {
    eventT = 15;
  }
  if (props.match.params.eventType === 'tennismatches') {
    eventT = 16;
  }
  if (props.match.params.eventType === 'soccerfullmarket') {
    eventT = 17;
  }
  if (props.match.params.eventType === 'tennisfullmarket') {
    eventT = 18;
  }
  if (props.match.params.eventType === 'casino') {
    eventT = 19;
  }
  if (props.match.params.eventType === 'skyslot') {
    eventT = 20;
  }



  const [openRightside, setopenRightside] = useState(false)
  const [VerifyClick, setVerifyClick] = useState(false)
  const [tabMenu, setTabMenu] = useState(eventT);

  useEffect(() => {
    setTabMenu(eventT);
  });

  console.log(eventT);
  const changeTab = () => {
    setTabMenu(0);
  }



  const Verifypopup = () => {
    setVerifyClick(true)
  }
  const Verifypopupfalse = () => {
    setVerifyClick(false)

  }

  const handlerightside = () => {
    setopenRightside(true)
  }
  const handlerightsideclose = () => {
    setopenRightside(false)
  }

  return (
    <div>
      <div>
        <Header tabMenu={tabMenu} />

        {tabMenu === 1 && <Carausel />}
   {tabMenu ===20 && <Skyslot/>}
        {tabMenu !== 1 && tabMenu !== 2 && tabMenu !== 3 && tabMenu !== 4 && tabMenu !== 5 && tabMenu !== 6 && tabMenu !== 7 && tabMenu !== 8 && tabMenu !== 9 && tabMenu !== 10 && tabMenu !== 11 && tabMenu !== 19 && tabMenu !== 20 && <Skycricket tabMenu={tabMenu} />}
        {tabMenu !== 1 && tabMenu !== 12 && tabMenu !== 13 && tabMenu !== 15 && tabMenu !== 16 && tabMenu !== 14 && tabMenu !== 18 && tabMenu !== 17 && tabMenu !== 19 && tabMenu !== 20 && <Deposit handlerightside={handlerightside} Verifypopup={Verifypopup} tabMenu={tabMenu} />}
        {openRightside === true && <Emailpopup handlerightsideclose={handlerightsideclose} />}
        {VerifyClick === true && <VerifyPhone Verifypopupfalse={Verifypopupfalse} />}
   {tabMenu === 19 && <Casino/>}
        
      
        
      {  <div className="side-slider contact-service-box">
          <button className="slide-btn">
            <img src={Title} alt="contact" />
          </button>
          <div className="side-slider-content">
            <div className="contact-service-icon">
              <img src={Blackcontect} alt="contact" />
            </div>
            <div className="contact-service-logo">
              <img src={Logo} alt="logo" />
            </div>
            <ul id="side-cs-cont" className="contact-service-list">
              <li id="cs-121">
                <a target="_blank">
                  <img src={Customerservice} ui-key="iconPath" alt="WhatsApp" />
                  <span ui-key="displayText">WhatsApp</span>
                </a>
                <hr />
              </li>
              <li id="cs-122">
                <a target="_blank" href="mailto:support@sky247.com">
                  <img src={Customerservice247} ui-key="iconPath" alt="email" />
                  <span ui-key="displayText">Support</span>
                </a>
                <hr />
              </li>
              <li id="cs-183">
                <a target="_blank">
                  <img src={Socialtelegram} ui-key="iconPath" alt="Telegram" />
                  <span ui-key="displayText">Telegram Support Channel</span>
                </a>
                <hr />
              </li>
              <li id="cs-162">
                <a target="_blank" href="mailto:mailto:skypartners@skyinfotechltd.com">
                  <img ui-key="iconPath" src={Customerservice247} alt="email" />
                  <span ui-key="displayText">Marketing</span>
                </a>
                <hr />
              </li>
              <li id="cs-161">
                <a target="_blank">
                  <img src={Socialtelegram2} ui-key="iconPath" alt="Telegram" />
                  <span ui-key="displayText">Telegram Group</span>
                </a>
                <hr />
              </li>
            </ul>
          </div>
        </div>
}

        <Footer />


      </div>

    </div>
  )
}
